import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Link, { NavLink } from 'redux-first-router-link';

import {
  IA_HELP_URL,
  IS_LOCAL_ENV,
  IS_QA_ENV,
  SHOW_USER_PERMISSIONS,
} from '@config';
import { ROUTE_FEATURE_FLAGS } from '@modules/featureFlags/duck/actions';
import { hasNewPermissionSel, isYouthMemberSel, logout } from '@shared';
import { Menu } from '@shared/components';
import { newPermissions } from '@shared/newPermissions';
import { openMasqueradeModal } from '@user';

import styles from './SettingsOptions.less';

const MenuItem = Menu.Item;
const MenuDivider = Menu.Divider;

const SettingsOptions = ({
  className,
  isMobile,
  onClick,
  onLogout,
  canMasquerade,
  onOpenMasqueradeModal,
  isYouthMember,
}) => {
  const notYouthMember = !isYouthMember;
  return (
    <Menu
      className={className}
      onClick={onClick}
      inlineCollapsed={false}
      mode="inline"
    >
      {SHOW_USER_PERMISSIONS && notYouthMember && (
        <React.Fragment>
          <MenuDivider className={styles.divider} />
          <MenuItem key="/user-permissions" className={styles.item}>
            <NavLink
              to="/user-permissions"
              className={styles.link}
              activeClassName={styles.activeLink}
              exact
            >
              <FormattedMessage id="core.Header.Settings.userPermissions" />
            </NavLink>
          </MenuItem>
        </React.Fragment>
      )}
      <MenuDivider className={styles.divider} />
      <MenuDivider className={styles.divider} />
      <MenuItem key="/help" className={styles.item}>
        <Link to={IA_HELP_URL} target="_blank" className={styles.link}>
          <FormattedMessage id="core.Header.Setting.help" />
        </Link>
      </MenuItem>
      <MenuDivider className={styles.divider} />
      <MenuItem key="/settings" className={styles.item}>
        <NavLink
          to="/settings"
          className={styles.link}
          activeClassName={styles.activeLink}
          exact
        >
          <FormattedMessage id="core.Header.Settings.settings" />
        </NavLink>
      </MenuItem>
      {canMasquerade && (
        <React.Fragment>
          <MenuDivider className={styles.divider} />
          <MenuItem key="/masquerade" className={styles.item}>
            <div className={styles.link} onClick={onOpenMasqueradeModal}>
              Masquerade
            </div>
          </MenuItem>
        </React.Fragment>
      )}
      {(IS_LOCAL_ENV || IS_QA_ENV) && (
        <React.Fragment>
          <MenuDivider className={styles.divider} />
          <MenuItem
            key="/feature-flags"
            className={styles.item}
            onClick={() => null}
          >
            <Link className={styles.link} to={ROUTE_FEATURE_FLAGS()}>
              Feature flags
            </Link>
          </MenuItem>
        </React.Fragment>
      )}
      {!isMobile && [
        <MenuDivider key="logout-divider" className={styles.divider} />,
        <MenuItem key="logout" className={styles.item}>
          <div id="qa_logout" className={styles.link} onClick={onLogout}>
            <FormattedMessage id="core.Header.Settings.logOut" />
          </div>
        </MenuItem>,
      ]}
    </Menu>
  );
};

SettingsOptions.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func,
  // Provided by Component itself
  canMasquerade: PropTypes.bool.isRequired,
  onLogout: PropTypes.func.isRequired,
  onOpenMasqueradeModal: PropTypes.func.isRequired,
  isYouthMember: PropTypes.bool.isRequired,
};

const mapState = state => ({
  canMasquerade: hasNewPermissionSel(state, newPermissions.MASQUERADE),
  isYouthMember: isYouthMemberSel(state),
});

const mapDispatch = dispatch => ({
  onLogout: () => dispatch(logout()),
  onOpenMasqueradeModal: () => dispatch(openMasqueradeModal()),
});

export default connect(mapState, mapDispatch)(SettingsOptions);
